// extracted by css-extract-rspack-plugin
export default {"fileInput":"fileInput-y7qtzz"};